import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

interface PerformanceData {
  name: string;
  count: number;
  min: number;
  max: number;
  avg: number;
  median: number;
  buckets: number[];
  bucketSize: number;
}

@Component({
  selector: 'app-performance',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatProgressBarModule, MatIconModule, MatTooltipModule],
  templateUrl: './performance.component.html',
  styleUrl: './performance.component.less'
})
export class PerformanceComponent implements OnInit {
  http = inject(HttpClient);
  data: PerformanceData[] = [];
  isLoading = true;
  API_URL = "/api/"

  constructor() {
    if (window.location.hostname === "localhost") {
      this.API_URL = "https://beta.jar.games/api/";
    }
  }

  ngOnInit() {
    this.http.get<{ data: PerformanceData[] }>(this.API_URL + 'performance/get.php').subscribe({
      next: (res) => {
        this.data = res.data.sort((a, b) => b.count - a.count);
        this.isLoading = false;
      },
      error: (err) => {
        console.error(err);
        this.isLoading = false;
      }
    });
  }

  getBucketHeight(count: number, allBuckets: number[]): number {
    const max = Math.max(...allBuckets);
    if (max === 0) return 0;
    return (count / max) * 100;
  }

  getBucketLabel(index: number, bucketSize: number, min: number): string {
    const start = min + (index * bucketSize);
    const end = start + bucketSize;
    return `${start.toFixed(1)}ms - ${end.toFixed(1)}ms`;
  }

  getCardTitle(name: string): string {
    if (name.startsWith("HTTP:")) {
      return name.split("/").slice(-2).join("/"); // return last 2 segments
    }
    return name;
  }
}
